import {cloneDeep} from 'lodash';
import {GET_PLAYERS} from '../constants';

const initialState = {
	data: [],
};

const players = (state = initialState, action) => {
	switch (action.type) {
		case GET_PLAYERS:
			return {
				...state, data: processPlayers(action.players, action.teams, action.playerImgPrefix),
			};
		default:
			return state;
	}
};

const processPlayers = (gPlayers, teams, playerImgPrefix) => gPlayers.map((player) => {
	const clone = cloneDeep(player);
	clone.team = teams[player.t].name;
	clone.image = playerImgPrefix.replace('{playerId}', player.id);
	return clone;
});

export default players;
